import { render, staticRenderFns } from "./IlhaAcoesMultiplas.vue?vue&type=template&id=04deb098&scoped=true&"
import script from "./IlhaAcoesMultiplas.vue?vue&type=script&lang=js&"
export * from "./IlhaAcoesMultiplas.vue?vue&type=script&lang=js&"
import style0 from "./IlhaAcoesMultiplas.vue?vue&type=style&index=0&id=04deb098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04deb098",
  null
  
)

export default component.exports